import React from 'react';
import { serialize } from '@techchange/pm-specs';
import handlebars from 'handlebars';
import PropTypes from 'prop-types';

import styles from './CertificatePreview.module.scss';

const propTypes = {

	/**
	 * The associated certificate layout.
	 */
	layout: PropTypes.shape({

		/**
		 * The HTML template string for the certificate body.
		 */
		html_body: PropTypes.string.isRequired,

	}).isRequired,

	/**
	 * The certificate template to preview.
	 */
	template: PropTypes.shape({

		/**
		 * The certificate template content, represented as a ProseMirror object.
		 */
		content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),

	}).isRequired,

	/**
	 * The list of template signatures with associated person data.
	 */
	signatures: PropTypes.arrayOf(PropTypes.shape({

		/**
		 * The person name.
		 */
		name: PropTypes.string.isRequired,

		/**
		 * The person affiliation.
		 */
		affiliation: PropTypes.string,

		/**
		 * The image source of the person signature.
		 */
		signature: PropTypes.string,

	})).isRequired,

	/**
	 * The certificate form data.
	 */
	formData: PropTypes.shape({

		/**
		 * Image source for the logo.
		 */
		logo: PropTypes.string,

		/**
		 * Image source for the badge.
		 */
		badge: PropTypes.string,

		/**
		 * Image source for the QR code.
		 */
		qr_code: PropTypes.string,

		/**
		 * Image source for the template background image.
		 */
		background_image: PropTypes.string,

	}).isRequired,

	/**
	 * The organization object.
	 */
	organization: PropTypes.shape({

		id: PropTypes.string.isRequired,

		emails: PropTypes.shape({

			primary_color: PropTypes.string,

		}),

	}),

};

const CertificatePreview = (props) => {

	const { layout, template, signatures, formData, organization } = props;

	const layoutHTML = layout && layout.html_body;

	const contentHTML = serialize(template.content);

	const layoutTags = {
		background_image: formData.background_image,
		badge: formData.badge,
		body: contentHTML,
		logo: formData.logo,
		organization,
		qr_code: formData.qr_code,
		signatures,
	};

	const previewHTML = `
		<html style="font-size: 1.5vw;">
			${handlebars.compile(layoutHTML)(layoutTags)}
		</html>
	`;

	return (
		<div className={styles['preview-container']}>
			<div className={styles['certificate-container']}>
				<iframe
					className={styles['preview']}
					srcDoc={previewHTML} />
			</div>
		</div>
	);

};

CertificatePreview.propTypes = propTypes;

export default CertificatePreview;
